import { render, staticRenderFns } from "./TopProductsChart.vue?vue&type=template&id=7168833e&scoped=true"
import script from "./TopProductsChart.vue?vue&type=script&lang=js"
export * from "./TopProductsChart.vue?vue&type=script&lang=js"
import style0 from "./TopProductsChart.vue?vue&type=style&index=0&id=7168833e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7168833e",
  null
  
)

export default component.exports